import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import { ComplaintFilters } from "@/api/backofficeRest/generated/model"
import { useMutation } from "@/api/utils/useQuery"
import { MutationResult } from "@/api/utils/types"
import { IDynamicComplaintSummaryFilters } from "./ComplaintMutator.types"

export interface IAdminComplaintMutator {
  getDynamicSummary(): MutationResult<IDynamicComplaintSummaryFilters>
}

class AdminComplaintMutatorClass implements IAdminComplaintMutator {
  getDynamicSummary() {
    return useMutation({
      ...BackofficeRestMutations.complaint.getDynamicSummary(),
      invalidateCache: false,
      serializerFn: (
        data: IDynamicComplaintSummaryFilters,
      ): ComplaintFilters => {
        return {
          dateRaised: data.dateRaised,
          ageProfileList: data.ageProfiles,
          statusList: data.status,
          subStatusList: data.subStatus,
          channelList: data.channel,
          typeList: data.type,
          category1List: data.category1,
          category2List: data.category2,
          category3List: data.category3,
          internalCategoryList: data.internalCategory,
          ofgemCategoryList: data.ofgemCategory,
          agentList: data.agentName,
          teamList: data.team,
        }
      },
    })
  }
}

export const AdminComplaintMutator = new AdminComplaintMutatorClass()
